export const isNotActive = () => {
    return Spark.state.currentTeam.status !== 'active';
};

export const displayNotActiveModal = () => {
    $('#modal-not-active-team').modal('show');
};
